import React, { useState } from "react";
import "./App.css";

const NICHES = [
  "Стоматология",
  "Пластическая хирургия",
  "Юридические услуги",
  "Натяжные потолки",
  "Окна и двери ПВХ",
  "Ремонт квартир",
  "Строительство домов",
  "Аренда спецтехники",
  "Грузоперевозки",
  "Автосервис",
  "Детские товары",
  "Интернет-магазин одежды",
  "Фитнес-клуб",
  "Языковые курсы",
  "Бухгалтерские услуги",
  "Недвижимость",
  "Свадебные услуги",
  "Доставка еды",
  "Клининг",
  "Другая ниша",
];

const STEPS = [
  { id: "niche", label: "Ниша" },
  { id: "city", label: "Регион" },
  { id: "leads", label: "Цель" },
  { id: "result", label: "Результат" },
];

export default function App() {
  const [step, setStep] = useState(0);
  const [niche, setNiche] = useState("");
  const [customNiche, setCustomNiche] = useState("");
  const [city, setCity] = useState("");
  const [leads, setLeads] = useState(30);
  const [budget, setBudget] = useState("");
  const [cac, setCac] = useState("");
  const [loading, setLoading] = useState(false);
  const [result, setResult] = useState("");
  const [error, setError] = useState("");

  const finalNiche = niche === "Другая ниша" ? customNiche : niche;

  const canNext = () => {
    if (step === 0) return niche !== "" && (niche !== "Другая ниша" || customNiche.trim() !== "");
    if (step === 1) return city.trim() !== "";
    if (step === 2) return leads > 0;
    return false;
  };

  const handleCalculate = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await fetch("/api/calculate", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ niche: finalNiche, city, leads, budget, cac }),
      });
      const data = await res.json();
      if (data.error) throw new Error(data.error);
      setResult(data.result);
      setStep(3);
    } catch (e) {
      setError("Что-то пошло не так. Попробуйте ещё раз.");
    } finally {
      setLoading(false);
    }
  };

  const reset = () => {
    setStep(0);
    setNiche("");
    setCustomNiche("");
    setCity("");
    setLeads(30);
    setBudget("");
    setCac("");
    setResult("");
    setError("");
  };

  const formatResult = (text) => {
    return text.split("\n").map((line, i) => {
      if (line.trim() === "") return <br key={i} />;
      return <p key={i} className={line.startsWith("📊") || line.startsWith("⚠️") || line.startsWith("💡") || line.startsWith("📞") ? "section-header" : ""}>{line}</p>;
    });
  };

  return (
    <div className="app">
      <div className="card">
        <div className="badge">Яндекс.Директ</div>
        <h1>Сколько нужно<br />на рекламу?</h1>
        <p className="subtitle">Получите персональный расчёт бюджета<br />для вашей ниши за 1 минуту</p>

        <div className="steps">
          {STEPS.map((s, i) => (
            <div key={s.id} className={`step-dot ${i === step ? "active" : ""} ${i < step ? "done" : ""}`}>
              {i < step ? "✓" : i + 1}
            </div>
          ))}
        </div>

        {step === 0 && (
          <div className="form-step">
            <label className="field-label">Выберите нишу</label>
            <div className="niche-grid">
              {NICHES.map((n) => (
                <button
                  key={n}
                  className={`niche-btn ${niche === n ? "selected" : ""}`}
                  onClick={() => setNiche(n)}
                >
                  {n}
                </button>
              ))}
            </div>
            {niche === "Другая ниша" && (
              <input
                className="text-input"
                placeholder="Укажите вашу нишу..."
                value={customNiche}
                onChange={(e) => setCustomNiche(e.target.value)}
                autoFocus
              />
            )}
          </div>
        )}

        {step === 1 && (
          <div className="form-step">
            <label className="field-label">Город или регион</label>
            <input
              className="text-input large"
              placeholder="Например: Москва, Самара, вся Россия..."
              value={city}
              onChange={(e) => setCity(e.target.value)}
              autoFocus
            />
          </div>
        )}

        {step === 2 && (
          <div className="form-step">
            <label className="field-label">Сколько лидов нужно в месяц?</label>
            <div className="slider-row">
              <input
                type="range"
                min="5"
                max="500"
                step="5"
                value={leads}
                onChange={(e) => setLeads(Number(e.target.value))}
                className="slider"
              />
              <span className="slider-value">{leads}</span>
            </div>
            <div className="optional-fields">
              <label className="field-label small">Текущий бюджет (необязательно)</label>
              <input
                className="text-input"
                placeholder="Например: 50 000 руб/мес"
                value={budget}
                onChange={(e) => setBudget(e.target.value)}
              />
              <label className="field-label small" style={{ marginTop: "1rem" }}>Стоимость вашего клиента (необязательно)</label>
              <input
                className="text-input"
                placeholder="Например: 15 000 руб"
                value={cac}
                onChange={(e) => setCac(e.target.value)}
              />
            </div>
          </div>
        )}

        {step === 3 && (
          <div className="form-step result-step">
            <div className="result-meta">
              <span className="tag">{finalNiche}</span>
              <span className="tag">{city}</span>
              <span className="tag">{leads} лидов/мес</span>
            </div>
            <div className="result-text">
              {formatResult(result)}
            </div>
            <button className="btn-secondary" onClick={reset}>← Рассчитать заново</button>
          </div>
        )}

        {error && <p className="error-msg">{error}</p>}

        {step < 3 && (
          <div className="nav-row">
            {step > 0 && (
              <button className="btn-back" onClick={() => setStep(step - 1)}>← Назад</button>
            )}
            {step < 2 ? (
              <button className="btn-next" disabled={!canNext()} onClick={() => setStep(step + 1)}>
                Далее →
              </button>
            ) : (
              <button className="btn-next" disabled={!canNext() || loading} onClick={handleCalculate}>
                {loading ? <span className="loader"></span> : "Рассчитать →"}
              </button>
            )}
          </div>
        )}
      </div>

      <p className="footer-note">Расчёт основан на реальных данных рынка и опыте директолога</p>
    </div>
  );
}
